import React, { useEffect } from 'react';
import { FiArrowRight } from 'react-icons/fi';

const SigninPage = () => {
    
    useEffect(()=>{document.body.style.background='#111827'})


    return (
        <React.Fragment>

            <div className="absolute left-20 top-10 w-52 h-52 bg-[#9715D9] blur-[80px]"></div>
            <div className="absolute left-72 top-72 w-52 h-52 bg-[#DA145F] blur-[80px]"></div>
            <div className="absolute left-20 top-96 w-52 h-52 bg-[#F71135] blur-[80px]"></div>
            <div className="absolute right-20 top-10 w-52 h-52 bg-[#3C45FA] blur-[80px]"></div>
            <div className="absolute right-52 top-72 w-52 h-52 bg-[#7E1FF9] blur-[80px]"></div>
      
            <form>
                <div className="w-full h-screen flex items-center justify-center text-white">
                    <div className="flex flex-col gap-6">
                        <div className="flex justify-between">
                            <div className="text-white">
                                <h1 className="text-5xl font-bold gradient-text">Welcome</h1>
                                <a href="/auth/signup" className="text-gray-200">Don't you have an account yet?</a>
                            </div>
                            <a href="/auth/signup" className="cursor-pointer"> <FiArrowRight size={33} className="text-white" /> </a>
                        </div>
                        <input defaultValue="" name="email" placeholder="Email" type="text" className="bg-transparent border-pink-500 border-2 rounded-md text-white p-3 w-96" />
                        <input name="password" placeholder="Password" type="password" className="bg-transparent border-purple-500 border-2 rounded-md text-white p-3 w-96" />

                        <button type="submit" className="bg-[#171927] hover:bg-gray-900 w-full shadow-md shadow-blue-500 p-3 rounded-full text-white flex items-center justify-center">Signin</button>
                        <div className="flex justify-between"> 
                            <a href="#">Remember me</a>
                            <a href="#">Forgotten?</a>
                        </div>
                    </div>
                </div>
            </form>
 
        </React.Fragment>
    )
}

export default SigninPage